import { AfterViewInit, Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { RevealDirective } from '../../directives/reveal.directive';
import { AnimationService } from '../../shared/services/animation.service';

import { signal } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule, RevealDirective],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements AfterViewInit {
  newsForm: FormGroup;
  successText = signal(false);

  currentYear: number = new Date().getFullYear();

  @ViewChild('footerSurface') footerSurface?: ElementRef<HTMLElement>;

  constructor(
    private fb: FormBuilder,
    private dataservice: DataService,
    private readonly animation: AnimationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.newsForm = this.fb.group({
      email: new FormControl("", [Validators.required, Validators.email])
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.footerSurface?.nativeElement) {
      this.animation.addFooterAnimations(this.footerSurface.nativeElement);
    }
  }

  onSubmit() {
    if (this.newsForm.valid) {
      this.dataservice.addNewsletter(this.newsForm.value.email);
      this.successText.set(true);
      this.newsForm.reset();

      // Auto-hide success message after 5 seconds
      setTimeout(() => this.successText.set(false), 5000);
    } else {
      this.newsForm.markAllAsTouched();
    }
  }
}
